var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isFormDisabled ? 'disable-div' : 'enable-div'},[(_vm.showGetSelectedDispatchesList)?_c('GetSelectedDispatchesList'):_vm._e(),(!_vm.showGetSelectedDispatchesList)?_c('AddOtherDispatchesToCurrentInvoice'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }